const lightTheme = {
  primary: '#1890FF',
  text: 'rgba(58,52,51,1)',
  textSecondary: 'rgba(58,52,51,0.7)',
  background: '#F0F2F5',
  backgroundVariant: 'rgba(251,249,249,1)',
  border: 'rgba(58,52,51,0.12)',
  borderLight: 'rgba(58,52,51,0.05)',
  black: '#262626',
  blue: '#1890FF',
  backgroundColor: '#FFFFFF',
  borderColor: '#D9D9D9',
  gray2: '#fafafa',

  taskStatusColor: {
    PLANNED: '#1890FF',
    IN_PROGRESS: '#FADB14',
    COMPLETED: '#389E0D',
    RECOMMENDED: '#722ED1',

    ACCEPTED: '#ffa700',
    DECLINED: 'red',
  },

  success: '#52c41a',

  activeItemBackground: '#E6F7FF',

  map: {
    tempField: {
      strokeColor: '#000000',
      fillColor: '#FAAD14',
      markerColor: '#ffa500',

      selectedFillColor: '#1890FF',
      selectedMarkerColor: '#1a90ff',
    },
  },
};

const darkTheme: Theme = {
  primary: '#1890FF',
  text: 'rgba(241,233,231,1)',
  textSecondary: 'rgba(241,233,231,0.6)',
  background: 'rgba(0,0,0,1)',
  backgroundVariant: 'rgba(28,26,26,1)',
  border: 'rgba(241,233,231,0.15)',
  borderLight: 'rgba(241,233,231,0.05)',
  black: '#262626',
  blue: '#1890FF',
  backgroundColor: '#2f2f2f',
  borderColor: '#D9D9D9',
  gray2: '#fafafa',

  taskStatusColor: {
    PLANNED: '#1890FF',
    IN_PROGRESS: '#FADB14',
    COMPLETED: '#389E0D',
    RECOMMENDED: '#722ED1',

    ACCEPTED: '#ffa700',
    DECLINED: 'red',
  },

  success: '#52c41a',

  activeItemBackground: '#E6F7FF',

  map: {
    tempField: {
      strokeColor: '#000000',
      fillColor: '#FAAD14',
      markerColor: '#ffa500',

      selectedFillColor: '#1890FF',
      selectedMarkerColor: '#1a90ff',
    },
  },
};

export type Theme = typeof lightTheme;

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
